import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(Box)`
  list-style-type: none;
  padding-inline-start: 0;
  margin: 0;

  &.bullets {
    padding-inline-start: 24px;

    &:where(ol) {
      list-style-type: decimal;
    }

    &:where(ul) {
      list-style-type: disc;
    }
  }
` as typeof Box;
